import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Text, Link, getPaletteColor } from 'pcln-design-system'
import { usePartner } from '@pcln/whitelabel-components'
import { NotificationImage, NotificationIcon } from '@pcln/notification'
import styled from 'styled-components'

const FlyinLink = styled(Link)`
  line-height: 20px;
  color: ${props =>
    props.flyinSeti === 'DEFAULT'
      ? 'blue'
      : getPaletteColor('primary.base')(props)};
`

const StyledBox = styled(Box)`
  display: none;
  ${props => props.theme.flyQueries.tablet} {
    display: block;
  }
`

const ListingsFlyin = ({
  flyinText,
  flyinText2,
  flyinImage,
  flyinLink,
  flyinSeti,
}) => {
  const [showBanner, setShowBanner] = useState(true)
  const partner = usePartner()

  const dismissBanner = () => {
    setShowBanner(false)
  }

  const headerContent = () => {
    return (
      <Text mr={3} bold color='text.dark'>
        {flyinText}
        {!!flyinText2 && (
          <Text regular mt={8} fontSize={1} color='text.light'>
            {flyinText2}
          </Text>
        )}
      </Text>
    )
  }

  const bodyContent = () => {
    return (
      <FlyinLink bold href={flyinLink} target='_blank' flyinSeti={flyinSeti}>
        View Flights
      </FlyinLink>
    )
  }

  const renderNotification = () => {
    return partner ? (
      <NotificationIcon
        renderHeaderContent={headerContent}
        handleCloseClick={dismissBanner}
        renderDynamicContent={bodyContent}
        animationDelay={2}
        iconColor='primary'
        iconName='Airplane'
        iconSize={85}
        leftBarColor='primary.base'
      />
    ) : (
      <NotificationImage
        renderHeaderContent={headerContent}
        renderDynamicContent={bodyContent}
        handleCloseClick={dismissBanner}
        animationDelay={2}
        imageUrl={flyinImage}
        leftBarColor={flyinSeti === 'DEFAULT' ? 'blue' : 'primary.base'}
      />
    )
  }

  return <StyledBox>{showBanner && renderNotification()}</StyledBox>
}

ListingsFlyin.propTypes = {
  flyinText: PropTypes.string.isRequired,
  flyinText2: PropTypes.string.isRequired,
  flyinImage: PropTypes.string.isRequired,
  flyinLink: PropTypes.string.isRequired,
  flyinSeti: PropTypes.string.isRequired,
}

export { ListingsFlyin }
